import IndoorPositioningPage from "../../../design-system/pages/indoor-positioning/index"

export default IndoorPositioningPage